import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { ValueSection } from './components/ValueSection';
import { RoadmapSection } from './components/RoadmapSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
import { initPixel, trackEvent } from './utils/pixel';
export function App() {
  useEffect(() => {
    initPixel();
    trackEvent('PageView');
  }, []);
  return <div className="min-h-screen bg-brand-dark text-brand-light font-sans selection:bg-brand-accent selection:text-brand-dark" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HookSection data-id="element-4" />
        <ValueSection data-id="element-5" />
        <RoadmapSection data-id="element-6" />
        <CtaSection data-id="element-7" />
      </main>

      <Footer data-id="element-8" />
    </div>;
}